export {useNotAvailableUnknownText} from './useNotAvailableUnknownText';